import { render } from "./AIMeetingRecap.vue?vue&type=template&id=4f0b6b80&scoped=true&ts=true"
import script from "./AIMeetingRecap.vue?vue&type=script&lang=ts"
export * from "./AIMeetingRecap.vue?vue&type=script&lang=ts"

import "./AIMeetingRecap.vue?vue&type=style&index=0&id=4f0b6b80&scoped=true&lang=css"
import "./AIMeetingRecap.vue?vue&type=style&index=1&id=4f0b6b80&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0b6b80"]])

export default __exports__